import { FC, useContext } from 'react';

import { AlertIcon, Button, H2, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { INotificationDeleteProps } from '../interfaces';
import s from './NotificationDelete.module.scss';

export const NotificationDelete: FC<INotificationDeleteProps> = ({
  title,
  description,
  onClose,
  showButton,
}) => {
  const { t } = useContext(LocalizationContext);
  return (
    <Modal
      style={{ padding: '0' }}
      onClose={onClose}
      className={s.container}
      disableOutsideClose
    >
      <div className={s.container}>
        <AlertIcon color={'warning'} size={'xxl'} className={s.icon} />
        <H2 className={s.title}>{title}</H2>
        <span className={s.subtitle}>{description}</span>
        {showButton && (
          <Button className={s.button} onClick={() => onClose()}>
            {t('close')}
          </Button>
        )}
      </div>
    </Modal>
  );
};
